export default __webpack_public_path__ + "static/media/pixellab--web-design--03a--600x450.f0f90f1b.jpg";